'use strict';
/**
 * Consumes the passed iterator and returns the number of items it contained.
 *
 * @param {AsyncIterable<any> | Iterable<any>} iterator
 * @returns {Promise<number>}
 */

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var length = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(iterator) {
    var count, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            count = 0;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 3;
            _iterator = _asyncIterator(iterator);

          case 5:
            _context.next = 7;
            return _iterator.next();

          case 7:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 13;
              break;
            }

            _ = _step.value;
            // eslint-disable-line no-unused-vars
            count++;

          case 10:
            _iteratorAbruptCompletion = false;
            _context.next = 5;
            break;

          case 13:
            _context.next = 19;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 19:
            _context.prev = 19;
            _context.prev = 20;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 24;
              break;
            }

            _context.next = 24;
            return _iterator.return();

          case 24:
            _context.prev = 24;

            if (!_didIteratorError) {
              _context.next = 27;
              break;
            }

            throw _iteratorError;

          case 27:
            return _context.finish(24);

          case 28:
            return _context.finish(19);

          case 29:
            return _context.abrupt("return", count);

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 15, 19, 29], [20,, 24, 28]]);
  }));

  return function length(_x) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = length;